<template>
  <div class="warehousingRecordPage">
    <div class="banner">
      <img src="../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">库存操作记录追溯</div>
    </div>
    <!-- <div class="input_box scan">
      <van-field
        v-model="searchTxt"
        ref="input"
        @focus="handleFocus"
        @blur="handleBlur"
        placeholder="输入SKU编码/ISBN编码查找匹配商品"
      />
    </div>
    <div class="primary-button query" @click="handleSearchMore">查看</div> -->

    <div class="input_wrap flex-rowl">
      <div class="input_box flex-rowl">
        <van-field
          v-model="searchTxt"
          ref="input"
          @focus="handleFocus"
          @blur="handleBlur"
          placeholder="输入SKU编码/ISBN编码"
        />
        <span class="iconfont icon-saoma" @click="handleSance"></span>
      </div>
      <div class="primary-button" @click="handleSearchMore">查找→</div>
    </div>

    <div class="main_content">
      <div class="title">最近入库操作记录</div>
      <div class="list" v-if="dataList.length > 0">
        <div
          class="item"
          v-for="item in dataList"
          :key="item.id"
          @click="handleDetail(item)"
        >
          <div class="goods_desciption">
             <p class="txt1 fontSize-blueColor-sm">
              入库数量：{{ item.num }}
            </p>
            <p class="txt1 fontSize-blueColor-sm">
              商品ID：{{ item.cm ? item.cm.id : "" }}
            </p>
            <p class="txt2 fontSize-blueColor-sm">商品名称：</p>
            <p class="txt3">{{ item.cm ? item.cm.commodityname : "" }}</p>
            <p class="txt3">{{ item.cm ? item.cm.commodityname_e : "" }}</p>
            <p class="txt3">{{ item.cm ? item.cm.commodityname_y : "" }}</p>
            <p class="txt3">{{ item.cm ? item.cm.commodityname_m : "" }}</p>
            <p class="txt3">{{ item.cm ? item.cm.commodityname_t : "" }}</p>
            <p class="txt1 fontSize-blueColor-sm">
              SKU采购编码：{{ item.cm ? item.cm.sku : "" }}
            </p>
            <!-- <p class="fontSize-blueColor-sm">
              ISBN编码： {{ item.cm ? item.cm.ISBN : "" }}
            </p> -->
          </div>
          <div class="operation operation_date">
            操作日期：<span>{{ item.createdate | formatDate  }}</span>
          </div>
          <div class="operation">
            操作人员：<span>{{ item.userman }}</span>
          </div>
          <div class="search_icon">
            <i class="iconfont icon-details"></i>
          </div>
        </div>
      </div>
      <van-empty v-else description="暂无数据" />

      <!-- <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回业务中心
      </div> -->
    </div>

    <!-- <Tabbar v-if="isShowTabbar"></Tabbar> -->
    <div class="fixd_button_btm" v-if="isShowTabbar">
      <div class="item" @click="handleReturn">返回</div>
    </div>
  </div>
</template>

<script>
let previousRouterName = "";
let previTxt = "";
import { queryShopWareRecord } from "../../api/api";
import storage from "../../utils/storage";
// import Tabbar from   "../../components/Tabbar.vue";
export default {
  name: "wRecordIndex",
  components: {
    // Tabbar,
  },
  data() {
    return {
      isShowTabbar: true,
      searchTxt: "",
      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      }else {
        return date
      }
    },
  },
  // back 返回页获取参数
  beforeRouteEnter(to, from, next) {
    console.log(to);
    previousRouterName = from.name;
    if (from.name === "qrcode") {
      previTxt = from.params.keyword;
    }
    next();
  },
  created() {
    this.initData();

    if (previousRouterName === "qrcode") {
      this.searchTxt = previTxt;
    }
  },
  methods: {
    initData() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      queryShopWareRecord({
        keyword: this.searchTxt,
        qyguid: this.$store.state.USERINFO.qy.qyguid,
      }).then((res) => {
        this.dataList = res;
        Toast.clear();
      });
    },

    handleDetail(item) {
      storage.set("DETAILITEM", item);
      this.$router.push("/recordIndex/wRecordDetail");
    },
    handleSearchMore() {
      if (this.searchTxt == "") {
        this.$toast("请输入SKU编码/ISBN编码");
        return;
      } else {
        this.$router.push(`/recordIndex/wRecordList/${this.searchTxt}`);
      }
    },
    handleReturn() {
      this.$router.back();
    },
    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },

    // 跳转扫码
    handleSance() {
      this.$router.push("/Qrcode");
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingRecordPage {
  .input_wrap {
    padding: 20px 45px 90px;
    box-sizing: border-box;
    .primary-button {
      width: 145px;
      margin-left: 20px;
      font-size: 26px;
    }
  }
  .query.primary-button {
    margin: 80px auto 66px;
  }
  .main_content {
    font-size: 30px;
    color: #444;
    padding: 0 50px 280px;
    .title {
      margin-bottom: 45px;
      text-align: center;
    }
    .item {
      border: 2px solid #dedede;
      padding: 39px 36px 65px;
      position: relative;
      border-radius: 30px;
      margin-bottom: 60px;
      .tit {
        font-size: 32px;
        text-align: left;
        margin-bottom: 40px;
        span {
          font-size: 28px;
          color: #f40728;
        }
      }
      .operation_date {
        margin: 50px 0 30px;
      }
      .operation {
        font-size: 26px;
        span {
          font-size: 26px;
          color: #f40728;
        }
      }
      .search_icon {
        // display: inline-block;
        // content: "";
        // background: url(../../assets/images/search-icon.png) no-repeat center;
        // background-size: cover;
        position: absolute;
        right: 29px;
        bottom: 34px;
        // width: 51px;
        // height: 52px;
        .icon-details {
          font-size: 50px;
          color: #515151;
        }
      }
    }
  }
}
</style>